import React, {
  useState,
  useEffect,
  createContext,
  useContext,
  useMemo,
} from 'react';
import { setShowLoginModalCallback } from 'controllers/login-modal-controller';

const LoginModalContext = createContext();

export function LoginModalProvider({ children }) {
  const [isLoginModalVisible, setLoginModalVisible] = useState(false);

  const showLoginModal = () => setLoginModalVisible(true);
  const hideLoginModal = () => setLoginModalVisible(false);

  useEffect(() => {
    setShowLoginModalCallback(showLoginModal);
  }, []);

  const contextValue = useMemo(
    () => ({
      isLoginModalVisible,
      showLoginModal,
      hideLoginModal,
    }),
    [isLoginModalVisible],
  );

  return (
    <LoginModalContext.Provider value={contextValue}>
      {children}
    </LoginModalContext.Provider>
  );
}

export const useLoginModal = () => useContext(LoginModalContext);
